import { ApiError } from '@formosa/shared/api/createClient';

/** 授權取圖錯誤分類（縮圖與 viewer 共用；行為與原縮圖實作相同）。 */
export function isStoryMediaAuthError(cause) {
  if (!(cause instanceof ApiError)) return false;
  if (cause.httpStatus === 401) return true;
  const code = cause.code;
  return code === 90003 || code === 90005 || code === 90001;
}

/** 登入已過期（由共用 client 以 JSON 相同規則判定並已派發 formosa:auth-expired）；不再導向登入、不重試。 */
export function isStoryMediaSessionExpired(cause) {
  return cause instanceof ApiError && cause.sessionExpired === true;
}

export function isStoryMediaUnavailable(cause) {
  if (!(cause instanceof ApiError)) return false;
  if (cause.httpStatus === 404) return true;
  return cause.code === 95200 || cause.raw?.key === 'travel.publication.projection.not.available';
}

export function isStoryMediaCanceled(cause) {
  return cause?.name === 'CanceledError' || cause?.code === 'ERR_CANCELED';
}

export function isStoryMediaRetryable(cause) {
  if (isStoryMediaCanceled(cause)) return false;
  if (isStoryMediaAuthError(cause) || isStoryMediaUnavailable(cause)) return false;
  if (cause instanceof ApiError) {
    if (cause.httpStatus === 503 || cause.code === 95210) return true;
    if (cause.networkCode) return true;
    if (cause.httpStatus == null && cause.code == null) return true;
  }
  return true;
}
